import { FileToDataUrl } from '@shared/utils/interfaces';
import { Observable, of } from 'rxjs';

export const fileToDataUrl = (file: File | null): Observable<FileToDataUrl | null> => {
  if (file) {
    return new Observable<FileToDataUrl>((observer) => {
      const reader = new FileReader();
      reader.onload = (): void => {
        observer.next({ file: reader.result as string, fileName: file.name });
        observer.complete();
      };
      reader.onerror = (): void => {
        observer.error(reader.error);
      };
      reader.readAsDataURL(file);
    });
  }

  return of(null);
};
